import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { factory, Title, useProps } from '@coveord/plasma-mantine';
import { useEmptyStateContext } from './EmptyStateContext.js';
var defaultProps = {};
export var EmptyStateTitle = factory(function(_props) {
    var ctx = useEmptyStateContext();
    var props = useProps('EmptyStateTitle', defaultProps, _props);
    var className = props.className, classNames = props.classNames, styles = props.styles, style = props.style, _unstyled = props.unstyled, children = props.children, ref = props.ref, others = _object_without_properties(props, [
        "className",
        "classNames",
        "styles",
        "style",
        "unstyled",
        "children",
        "ref"
    ]);
    var titleSize = {
        small: 5,
        feedback: 2,
        'first-use': 2
    };
    return /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({
        ref: ref,
        order: titleSize[ctx.variant]
    }, ctx.getStyles('title', {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others), {
        children: children
    }));
});
EmptyStateTitle.displayName = 'EmptyState.Title';

//# sourceMappingURL=EmptyStateTitle.js.map